module.exports = __webpack_public_path__ + "static/media/uno-wallpaper.268c2a71.png";